import { CreateSupportReq } from '../../dto/ReqDtoRepository';
import { SupportResponse } from '../../dto/ResDtoRepository';
import { useTempAlertStore } from '../../store/portal/tempAlertStore';
import { getTempAlertMessage } from '../../constants/tempAlertMessages';
import { useApiWrapper } from './apiWrapper';
import { createSupport } from '../../api/supportApi';
import { useModalStore } from '../../store/portal/modalStore';
import { TempAlertPosition } from '../../enum/EnumRepository';
import { TempAlertType } from '../../enum/EnumRepository';

interface UseSupportResult {
  createSupport: (aui: string, data: CreateSupportReq) => Promise<void>;
}

export const useSupport = (): UseSupportResult => {
  const { clearModal } = useModalStore();
  const { setTempAlert } = useTempAlertStore();
  const withApiHandler = useApiWrapper();

  const handleCreateSupportSuccess = (response: SupportResponse) => {
    setTempAlert({
      type: TempAlertType.UPDATED,
      position: TempAlertPosition.RB,
      content: getTempAlertMessage('MESSAGE_SENT_THANKS'),
      duration: 2000
    });
    clearModal();
  };

  const handleSupportRequest = async (
    aui: string,
    action: 'create',
    data?: CreateSupportReq,
  ) => {
    const apiFunction = async () => {
      switch (action) {
        case 'create':
        default:
          handleCreateSupportSuccess(await createSupport(aui, data as CreateSupportReq));
          break;
      }
    };

    await withApiHandler(apiFunction, [aui, action, data]);
  };

  const createSupportHandler = (aui: string, data: CreateSupportReq) => handleSupportRequest(aui, 'create', data);

  return {
    createSupport: createSupportHandler,
  };
};